module.exports = __webpack_public_path__ + "img/Smartphone.5de20bdf.svg";